import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getStudentByID } from "state/school_money/selectors";

/**
 * @param {boolean} first = true - should show first name?
 * @param {boolean} last = true - should show last name?
 */
class StudentName extends React.Component {
  
  static propTypes = {
    first: PropTypes.bool,
    last: PropTypes.bool
  }
  
  static defaultProps = {
    first: true,
    last: true
  }
  
  render() {
    const { student, first, last } = this.props;
    const { firstName, lastName } = student;
    if (first && last) {
      return `${firstName} ${lastName}`;
    }
    if (first) {
      return firstName;
    }
    if (last) {
      return lastName;
    }
    return null;
  }
  
}

export default connect(
  (state, { studentID }) => ({
    student: getStudentByID(state, studentID)
  })
)(StudentName);



// WEBPACK FOOTER //
// ./src/components/school_money/StudentName.js